module.exports = __webpack_public_path__ + "img/head.a1e76142.png";